import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  status: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    gap: '6px',
    width: 'fit-content',

    '& > *': {
      pointerEvents: 'none',
    },

    '& .eventStatusIndicator': {
      '& .statusDot': {
        display: 'none',
      },

      '& .statusLabel': {
        color: 'var(--status-color)',
      },
    },

    '@media screen and (min-width: 1441px)': {
      gap: '8px',
    },
  },
}));

export default useStyles;
